import { render } from "./soa.vue?vue&type=template&id=0246b790&scoped=true"
import script from "./soa.js?vue&type=script&lang=js"
export * from "./soa.js?vue&type=script&lang=js"

import "./soa.vue?vue&type=style&index=0&id=0246b790&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0246b790"]])

export default __exports__